import { render, staticRenderFns } from "./workerDataWork.vue?vue&type=template&id=210e65bc&"
import script from "./workerDataWork.vue?vue&type=script&lang=js&"
export * from "./workerDataWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports